import { NavigationList } from './NavigationList';

export default NavigationList;
